import React, { ReactNode } from 'react'
import useScript from 'react-script-hook'
import { Trans } from '@lingui/macro'

interface IProps {
  children: ReactNode
  viewId: string
  authImmediate: boolean
  origin?: string
  onChange: (data: any) => void
  multiselect?: boolean
  navHidden?: boolean
  disabled?: boolean
  mimeTypes?: string[]
  query?: string
}

let status
let accessToken

export const GooglePicker = (props: IProps) => {
  useScript({
    src: 'https://apis.google.com/js/api.js',
    onload: () => {
      onApiLoad()
      status = 'ready'
    }
  })

  const onApiLoad = () => {
    window.gapi.load('auth2')
    window.gapi.load('picker')
  }

  const clientId =
    '308585433820-t57l0sdd9lr8hjj7pl0erth550vgnafm.apps.googleusercontent.com'
  const onChoose = async () => {
    if (accessToken) {
      createPicker(accessToken)
    } else {
      window.gapi.auth2.authorize(
        {
          client_id: clientId,
          scope: 'https://www.googleapis.com/auth/drive.file'
        },
        function (response) {
          if (response.error) {
            return
          }

          accessToken = response.access_token

          window.gapi.load('picker', () => {
            createPicker(accessToken)
          })
        }
      )
    }
  }

  const createPicker = (oauthToken) => {
    const googleViewId = window.google.picker.ViewId[props.viewId]
    const view = new window.google.picker.View(googleViewId)

    if (props.mimeTypes) {
      view.setMimeTypes(props.mimeTypes.join(','))
    }

    if (props.query) {
      view.setQuery(props.query)
    }

    if (!view) {
      throw new Error("Can't find view by viewId")
    }

    const sharedDrives = new window.google.picker.DocsView(
      window.google.picker.ViewId.DOCS
    )
      .setIncludeFolders(true)
      .setEnableDrives(true)

    const picker = new window.google.picker.PickerBuilder()
      .enableFeature(window.google.picker.Feature.SUPPORT_DRIVES)
      .setAppId(clientId.split('-')[0])
      .setOAuthToken(oauthToken)
      .setDeveloperKey('AIzaSyBnDL9bRk8YtMwiorlfTD4WEbvMKtwnDzg')
      .addView(sharedDrives)
      .setCallback(props.onChange)

    if (props.origin) {
      picker.setOrigin(props.origin)
    }

    if (props.navHidden) {
      picker.enableFeature(window.google.picker.Feature.NAV_HIDDEN)
    }

    if (props.multiselect) {
      picker.enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
    }

    picker.build().setVisible(true)
  }

  return (
    <div>
      {status === 'ready' && (
        <div onClick={onChoose}>
          {props.children ? (
            props.children
          ) : (
            <button>
              <Trans>Open Google file picker</Trans>
            </button>
          )}
        </div>
      )}
    </div>
  )
}
